<template>
    <span class="inline-block ml-2 px-2 leading-snug rounded-full text-xs font-bold text-white bg-error"
        v-if="unreadCount">
        {{ unreadCount }}
    </span>
</template>

<script>
export default {

    data() {
        return {
            unreadCount: 0
        }
    },

    methods: {
        getUnreadCount() {
            axios
                .get(url(`/conversations/unread-count`))
                .then(response => this.unreadCount = response.data.count)
                .catch(errors => {
                    if (errors.response.status === 403) {
                        alert('Platnost stránky vypršela');
                        window.location.reload();
                        return;
                    }

                    alert('unexpected error');
                    console.log(errors.response);
                });
        }
    },

    mounted() {
        this.getUnreadCount();
        setInterval(this.getUnreadCount, 50000);

        document.addEventListener('visibilitychange', this.getUnreadCount);
    }
}
</script>
